import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class PIs extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			PERSON_NAME: '',
			ACTIVE_FLAG: 'Yes'
		};
		
		// initialize pi list
		var initialPIList = this.copyPIList();
		initialPIList.query.search = this.constructSearch(search);
		
		// remove add/edit column if not authorized
		if (props.user.crs.userAccessID !== 1) {
			initialPIList.columns.splice(0, 1);
		}
		
		this.state = {
			renderKey: 1,
			piList: initialPIList,
			search: search,
			searchCount: null
		};
	}
	
	copyPIList() {
		var piListCopy = this.copyObject(piList);
		for (var i = 0; i < piList.columns.length; i++) {
			if (piList.columns[i].Header) {
				piListCopy.columns[i].Header = piList.columns[i].Header;
			}
			if (piList.columns[i].Cell) {
				piListCopy.columns[i].Cell = piList.columns[i].Cell;
			}
		}
		return piListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newPIList = this.copyPIList();
		newPIList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			piList: newPIList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.PERSON_NAME)) search.Children.push({ Attribute: 'PERSON_NAME', Operator: 'like', StringValue: '%' + data.PERSON_NAME + '%' });
		if (data.ACTIVE_FLAG === 'No' || data.ACTIVE_FLAG === 'Yes') {
			if (data.ACTIVE_FLAG === 'Yes') {
				search.Children.push({ Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' });
			} else {
				search.Children.push({ Operator: 'or', Children: [
					{ Attribute: 'ACTIVE_FLAG', Operator: '!=', StringValue: 'Y' },
					{ Attribute: 'ACTIVE_FLAG', Operator: 'is null' } ] } ); 
			}
		}

		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}
	
	addPerson() {
		this.props.navigate('/CRS/People/new');
	}
	
	editPerson(roleId) {
		this.props.navigate('/CRS/People/' + roleId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'PIs',
			columns: exportColumns,
			entity: 'RECHARGES.PI_SEARCH_VW',
			search: this.constructSearch(this.state.search),
			order: 'PERSON_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>PIs (Fund Managers)</span>
					<ChemEdit parent={this} columns={piSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_PIs' table={this.state.piList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const piSearch = [
	{ Header: 'Name', accessor: 'PERSON_NAME', row: 0, col: 0 },
	{ Header: 'Active', accessor: 'ACTIVE_FLAG', row: 0, col: 1, type: 'select',
		options: [{ value: 'All', label: 'All' }, { value: 'No', label: 'No' }, { value: 'Yes', label: 'Yes' }] }
];

const piList = {
	query: { entity: 'RECHARGES.PI_SEARCH_VW', search: null, order: 'PERSON_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addPerson()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editPerson(props.row.values.ROLE_ID)} />, width: 25 },
		{ Header: 'PI Name', accessor: 'PERSON_NAME', width: 200 },
		{ Header: 'Appt Type', accessor: 'TYPE_DISPLAY', width: 400 },
		{ Header: 'Department', accessor: 'DEPT', width: 200 },
		{ Header: 'Email', accessor: 'EMAIL', width: 250 },
		{ Header: 'RA', accessor: 'RA', width: 200 },
		{ Header: 'ROLE_ID', accessor: 'ROLE_ID', show: false }
	]
};

const exportColumns = [
		{ Header: 'PI Name', accessor: 'PERSON_NAME', width: 30 },
		{ Header: 'Appt Type', accessor: 'TYPE_DISPLAY', width: 60 },
		{ Header: 'Department', accessor: 'DEPT', width: 30 },
		{ Header: 'Email', accessor: 'EMAIL', width: 35 },
		{ Header: 'RA', accessor: 'RA', width: 30 }
];

export default withRouter(PIs);